var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.152 2h.644c.515 0 .94 0 1.288.024.361.024.695.077 1.017.21A3.076 3.076 0 0111.765 3.9c.133.322.186.656.21 1.017.024.348.024.773.024 1.288v.027a.77.77 0 01-1.539 0c0-.548 0-.921-.02-1.21-.019-.283-.054-.43-.097-.533a1.539 1.539 0 00-.832-.832c-.103-.043-.25-.078-.533-.097-.29-.02-.662-.02-1.21-.02h-.577c-.826 0-1.388 0-1.818.044-.417.043-.624.119-.767.215a1.538 1.538 0 00-.425.424c-.096.144-.172.35-.214.768-.044.43-.045.991-.045 1.818v10.384c0 .826.001 1.388.045 1.818.042.417.118.624.214.768.113.168.257.312.425.424.143.096.35.172.767.215.43.043.992.044 1.818.044.827 0 1.388 0 1.818-.044.417-.043.624-.119.768-.215.168-.112.312-.256.424-.424.096-.144.172-.35.215-.768.044-.43.044-.992.044-1.818v-3.461a.77.77 0 011.539 0v3.501c0 .777 0 1.417-.053 1.934-.054.539-.173 1.028-.466 1.466a3.078 3.078 0 01-.848.85c-.439.292-.928.41-1.467.465C8.649 22 8.009 22 7.232 22h-.08c-.776 0-1.416 0-1.933-.053-.54-.055-1.028-.173-1.467-.466a3.077 3.077 0 01-.849-.849c-.293-.438-.411-.927-.466-1.466-.052-.517-.052-1.157-.052-1.934V6.768c0-.777 0-1.417.052-1.934.055-.539.173-1.028.466-1.467.225-.335.513-.624.85-.848.438-.293.927-.412 1.466-.466C5.736 2 6.376 2 7.152 2z",
    fill: "#00163E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.231,
    y: 13.538,
    width: 5.385,
    height: 8.462,
    rx: 2,
    fill: "#00163E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.615 10.203c0-.94.723-1.72 1.66-1.792l10.951-.842a2.219 2.219 0 11.17 4.431H8.413a1.797 1.797 0 01-1.798-1.797z",
    fill: "#00163E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M9.853 10.065l-.148.327m3.985-.737l-.285.589m4.132-.971l-.46.956"
  })));
}
export default SvgFastag;